// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\shared\\\\PeopleSection\\\\components\\\\PersonCard.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\shared\\PeopleSection\\components\\PersonCard.tsx");
  import.meta.hot.lastModified = "1757171103357.4683";
}
// REMIX HMR END

export function PersonCard({
  photo,
  name,
  surname,
  role,
  location,
  href
}) {
  return <a href={href} className="group block overflow-hidden transition-all duration-300 hover:scale-[1.02]">
      {/* Photo */}
      <div className="aspect-[3/4] overflow-hidden bg-neutral-100 mb-2 lg:mb-4">
        <img src={photo} alt={`${name} ${surname} - ${role}`} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105 grayscale group-hover:grayscale-0" loading="lazy" />
      </div>

      {/* Person Info */}
      <div className="space-y-0.5 lg:space-y-1">
        <h3 className="text-body-3 lg:text-heading-5 tracking-[-0.01em] !text-black uppercase leading-tight">
          {name} {surname}
        </h3>
        <p className="text-button-small lg:text-body-3 !text-black/60 capitalize">
          {role}
        </p>
      </div>
    </a>;
}
_c = PersonCard;
var _c;
$RefreshReg$(_c, "PersonCard");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;